import './AboutContent.css';

import React from 'react'
import { Link } from 'react-router-dom';
import React1 from "../assets/MoudisaResume2024.jpg";
import React2 from "../assets/img-4.jpg";

const AboutContent = () => {
  return (
    <div className='about'>
        <div className='left'>
            <h1>Who Am I?</h1>
            <p>
                I'm a friendly software engineer with expertise in frontend development, proficiency in backend, database and cloud services!
            </p>
            <Link to="https://moudisa-bucket-1.s3.ap-south-1.amazonaws.com/Resume/MoudisaResume2024.pdf">
                <button className='btn'>Download Resume</button>
            </Link>
        </div>
        <div className='right'>
            <div className='img-container'>
                <div className='img-stack top'>
                    <img src={React2} className='img' alt='image'/>
                </div>
                <div className='img-stack bottom'>
                    <img src={React1} className='img' alt='true'/>
                </div>
            </div>
        </div>
      
    </div>
  )
}

export default AboutContent
